<template>
  <span style="" v-if="giftData && giftData.denomination">
    <span style="display: flex">
        <van-icon name="point-gift" color="#EE0A24" size="20px" style="margin: auto 0"/>
        <span style="margin: auto 0" class="text_style" v-if="size==='xs'">¥{{ giftData.denomination }}</span>
        <span style="margin: auto 0" class="text_style" v-else-if="size==='xl'">礼金: ¥<span
            class="money_xl">{{ giftData.denomination }}</span></span>
        <span style="margin: auto 0" class="text_style" v-else-if="size==='xxl'">礼金: ¥<span
            class="money_xxl">{{ giftData.denomination }}</span></span>
    </span>
  </span>
</template>
<script>
export default {
  props: {
    giftData: { type: Object, default: null },
    size: { type: String, default: 'xs' }
  }
}
</script>
<style>
.text_style {
  font-size: 14px;
  color: #EE0A24;
}

.money_xl {
  font-size: 14px;
  font-weight: bold;
}

.money_xxl {
  font-size: 20px;
  font-weight: bold;
}

</style>